import React from 'react';
import styled from 'styled-components';

import Section from '../../common/Section';
import ContentPost from '../../common/contentPost/Post';
import ContentTitle from '../../common/contentPost/Title';

const PressPost = (props) => {
  const { pressRelease } = props;

  return (
    <StyledSection>
      <ContentTitle title={pressRelease.title} date={pressRelease.date} />
      <ContentPost html={pressRelease.content.html} />
    </StyledSection>
  );
};

const StyledSection = styled(Section)`
  max-width: 1100px;
  margin: 0 auto 250px;
  padding-top: 110px;
`;

export default PressPost;
